export default __webpack_public_path__ + "static/media/cark-title.ca742040.svg";